import React, { FC } from 'react'
import { scoreboardConstants } from '../../../constants/scoreboardConstants'
import ScoreboardCardContent from './components/ScoreboardCardContent'
import ScoreboardCardIcon from './components/ScoreboardCardIcon'
import ScoreboardCardSkeleton from './components/ScoreboardCardSkeleton'

export interface ScoreboardCardStyle {
	title: string
	iconColor: string
	background: string
	customColor?: string
}

interface ScoreboardCardProps {
	icon?: string
	title: string
	subtext: string
	iconStyle?: string
	star?: boolean
	style?: ScoreboardCardStyle
	isLoading: boolean
}

const ScoreboardCard: FC<ScoreboardCardProps> = ({
	icon,
	title,
	subtext,
	iconStyle,
	star = false,
	style,
	isLoading,
}) => {
	if (isLoading) {
		return <ScoreboardCardSkeleton style={style} />
	}

	return (
		<div
			className={`flex flex-row items-center bg-[#f5f5f5] dark:bg-surface-dark p-5 ${scoreboardConstants.card.aspectRatio} ${scoreboardConstants.card.roundedStyle} ${style?.background ?? scoreboardConstants.card.borderStyle}`}
		>
			<ScoreboardCardIcon icon={icon} star={star} iconStyle={iconStyle} />
			<ScoreboardCardContent title={title} subtext={subtext} customColor={style?.customColor} />
		</div>
	)
}

export default ScoreboardCard
